/**
 * Converts Bulgarian Lev (BGN) to Euro (EUR)
 * @param {number} bgnAmount - The amount in Bulgarian Lev
 * @returns {number} - The amount converted to Euro with proper rounding
 * 
 * Conversion rules:
 * - Rate: 1 BGN = 1/1.95583 EUR
 * - Rounding: ≥ 0.005 is rounded up, < 0.005 is rounded down
 */
export function bgnToEur(bgnAmount) {
  if (typeof bgnAmount !== 'number' || isNaN(bgnAmount)) {
    return 0;
  }
  
  const rate = 1.95583;
  const eurAmount = bgnAmount / rate;
  
  // Apply the specific rounding rules
  // Multiply by 100 to get to cents, round to integer, then divide by 100 to get back to euros
  const eurAmountRounded = Math.round(eurAmount * 100) / 100;
  
  return eurAmountRounded;
}

/**
 * Converts Euro (EUR) to Bulgarian Lev (BGN)
 * @param {number} eurAmount - The amount in Euro
 * @returns {number} - The amount converted to Bulgarian Lev with proper rounding
 * 
 * Conversion rules:
 * - Rate: 1 EUR = 1.95583 BGN
 * - Rounding: ≥ 0.005 is rounded up, < 0.005 is rounded down
 */
export function eurToBgn(eurAmount) {
  if (typeof eurAmount !== 'number' || isNaN(eurAmount)) {
    return 0;
  }
  
  const rate = 1.95583;
  const bgnAmount = eurAmount * rate;
  
  // Apply the specific rounding rules
  // Multiply by 100 to get to cents, round to integer, then divide by 100 to get back to levs
  const bgnAmountRounded = Math.round(bgnAmount * 100) / 100;
  
  return bgnAmountRounded;
}